import moment from 'moment';
import { connect } from 'react-redux';
import { Forms } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { IPais, IRegion } from '../../../services/api/entity/model';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import Security from '../../../services/seguridad';
import Loader from '../../loader';
import { Accordion, AccordionTab } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import CnetDropdown from '../../cnet/CnetDropdown';
import API from '../../../services/api';
import { CotizadorComboItem } from '../../../model/clientes';
import Common from '../../../services/common';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  paises?: IPais[] | null | undefined;
  regiones?: IRegion[] | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionCotizacion({ storage, t,
  data,
  paises, regiones, 
  onUpdateFields
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);
  
  if (!data) return <></>;
  const enabledEditCotizacion = Security.HasPermiso(84);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Cotizacion}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <CnetDropdown
          title={t("Seccion.Field.Cliente")} t={t} useActiveDinamicFilter
          value={data?.cliente?.id}
          optionLabel="show" optionValue="id"
          optionsAsync={(activos) => API.ClientesController().Cliente().combo({ activos })}
          optionsTransform={(data) => Common.array.ComboItem(t, data)}
          onChange={e => onUpdateFields([ 
            { field: 'cliente.id', value: e.value },
            !!data?.operacion?.id ? undefined : { field: 'cotizacion.idvendedor', value: undefined },
            !data?.operacion?.id ? undefined : { field: 'operacion.idvendedor', value: undefined },
          ].filter(p => !!p) as any)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <CnetDropdown
          title={t("Seccion.Field.Cotizador")} t={t} useActiveDinamicFilter
          value={data?.cotizador?.id}
          optionLabel="show" optionValue="id"
          optionsAsync={(activos) => API.ClientesController().Cotizador().combo({ activos })}
          optionsTransform={(arr:CotizadorComboItem[]) => [
            ...Common.array.ComboItem(t, arr.filter(p => p.idCliente === data?.cliente.id))
          ]}
          onChange={e => onUpdateField('cotizador.id', e.value)}
        />
      </div>
    </div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Loader loading={!paises}>
          <Forms.Dropdown
            title={t("Seccion.Field.Origen")}
            className={styles["fix-form-component"]}
            disabled={!enabledEditCotizacion}
            value={data?.operacionproducto?.idorigen ?? data?.cotizacion?.idorigen ?? data?.calcpedido?.origen}
            options={() => paises ?? []} optionLabel="nombre" optionValue="id"
            onChange={(v,e) => onUpdateField('cotizacion.idorigen', v)}
          />
        </Loader>
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Loader loading={!regiones}>
          <Forms.Dropdown
            title={t("Seccion.Field.Destino")}
            className={styles["fix-form-component"]}
            disabled={!enabledEditCotizacion}
            value={data?.operacionproducto?.iddestino ?? data?.cotizacion?.iddestino ?? data?.calcpedido?.destino}
            options={() => regiones ?? []} optionLabel="nombre" optionValue="id"
            onChange={(v,e) => onUpdateField('cotizacion.iddestino', v)}
          />
        </Loader>
      </div>
    </div>
    <div className='p-grid'>
      <div className='p-col-12 p-lg-5 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.FechaDesde")}
          className={styles["fix-form-component"]}
          disabled={!enabledEditCotizacion}
          value={new Date(data?.operacion?.fechadesde ?? data!.cotizacion!.fechadesde)} 
          onChange={(v,e) => {
            const desde = new Date(data?.operacion?.fechadesde ?? data!.cotizacion!.fechadesde);
            const hasta = new Date(data?.operacion?.fechahasta ?? data!.cotizacion!.fechahasta);
            const dias = moment(hasta).diff(moment(desde), 'days') + 1;
            onUpdateFields([
              { field: !data?.operacion?.id ? 'cotizacion.fechadesde' : 'operacion.fechadesde', value: v },
              { field: !data?.operacion?.id ? 'cotizacion.fechahasta' : 'operacion.fechahasta', value: Common.date.add(new Date(v as any), 0, 0, dias - 1) },
            ]);
          }}
        />
      </div>
      <div className='p-col-12 p-lg-5 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.FechaHasta")}
          className={styles["fix-form-component"]}
          disabled={!!data?.operacion?.id}
          value={window.getDate(data?.operacion?.fechahasta ?? data?.cotizacion?.fechahasta, window.app_usems)} 
          onChange={(v,e) => onUpdateField(!!data?.operacion?.fechahasta ? 'cotizacion.fechahasta' : 'operacion.fechahasta', v)}
        />
      </div>
      <div className='p-col-12 p-lg-2 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.Dias")}
          className={styles["fix-form-component"]}
          disabled={true}
          value={`${moment(window.getDate(data?.operacion?.fechahasta ?? data?.cotizacion?.fechahasta, window.app_usems)).diff(window.getDate(data?.operacion?.fechadesde ?? data?.cotizacion?.fechadesde, window.app_usems), 'days') + 1}`} 
          //onChange={(v,e) => onUpdateField('cotizacion.fechahasta', v)}
        />
      </div>
    </div>

    <div className='p-grid'>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.CodigoDescuento")}
          className={styles["fix-form-component"]}
          disabled={!enabledEditCotizacion}
          value={data?.cotizacion?.codigodescuento ?? data?.calcpedido?.codigodescuento} 
          onChange={(v,e) => onUpdateField('cotizacion.codigodescuento', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.Ip")}
          className={styles["fix-form-component"]}
          disabled={!enabledEditCotizacion}
          value={data?.cotizacion.ip}
          onChange={(v,e) => onUpdateField('cotizacion.ip', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.cotizacion.edades")}
          className={styles["fix-form-component"]}
          disabled={!enabledEditCotizacion}
          value={data?.cotizacion?.edades ?? (data?.operacionpasajeros?.length ? ( data.operacionpasajeros.sort((a,b) => (a.orden??0) > (b.orden??0) ? 1 : -1).map(p => p.edad) ) : data?.calcpedido?.edades)}
          //onChange={(v,e) => onUpdateField('cotizacion.edades', v)}
        />
      </div>
    </div>

    <div className='p-grid'>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.cotizacion.acceso")}
          className={styles["fix-form-component"]}
          disabled={!enabledEditCotizacion}
          value={data?.cotizacion.acceso} 
          onChange={(v,e) => onUpdateField('cotizacion.acceso', v)}
        />
      </div>
    </div>

    <Accordion activeIndex={[]}>
      <AccordionTab header={t("Seccion.Cotizacion.SubSection.Filtros")}>
        <div className='p-grid'>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input
              title={t("Seccion.Field.Proveedores")}
              className={styles["fix-form-component"]}
              disabled={true}
              value={data?.cotizacion?.fproveedores ?? data?.calcpedido?.proveedores}
              //onChange={(v,e) => onUpdateField('cotizacion.fproveedores', v)}
            />
          </div>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input
              title={t("Seccion.Field.TipoViaje")}
              className={styles["fix-form-component"]}
              disabled={true}
              value={data?.cotizacion.ftipoviaje ?? data?.calcpedido?.tipoproductos}
              //onChange={(v,e) => onUpdateField('cotizacion.ftipoviaje', v)}
            />
          </div>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input
              title={t("Seccion.Field.Coberturas")}
              className={styles["fix-form-component"]}
              disabled={true}
              value={data?.cotizacion.fcoverturas ?? ((!!data?.calcpedido?.coverturadesde || !!data?.calcpedido?.coverturahasta) ? `${data?.calcpedido?.coverturadesde}-${data?.calcpedido?.coverturahasta}` : undefined)}
              //onChange={(v,e) => onUpdateField('cotizacion.fcoverturas', v)}
            />
          </div>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input
              title={t("Seccion.Field.Tarifas")}
              className={styles["fix-form-component"]}
              disabled={true}
              value={data?.cotizacion.ftarifas ?? ((!!data?.calcpedido?.tarifadesde || !!data?.calcpedido?.tarifahasta) ? `${data?.calcpedido?.tarifadesde}-${data?.calcpedido?.tarifahasta}` : undefined)}
              //onChange={(v,e) => onUpdateField('cotizacion.ftarifas', v)}
            />
          </div>
        </div>
      </AccordionTab>
    </Accordion>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionCotizacion);
